<section class="sct">
    <header class="col-12 header-page">
        <h1 class="header__page__content__title">
            Simulador de previdência líquida
        </h1>
        <p>
            O Beneficiário terá a possibilidade de realizar uma simulação do seu benefício com a idade mínima para se
            aposentar segundo as regras da Fundação Copel. Lembrando que, para o beneficiário ter direito a
            aposentadoria é necessário ter idade igual ou superior a 45 anos, 5 anos de contribuição ao Plano, tenha se
            desligado da patrocinadora e o valor do benefício mínimo igual ou superior a duas UPs, ou seja R$ 1.065,24
        </p>
    </header>
    <main class="main__content col-xl-12">
        <form class="col-xl-12 col-lg-12 col-md-12 col-sm-12 main__page__content__form" [formGroup]="formGroup"
            (ngSubmit)="consultar()">
            <section class="col-12 content-form">
                <div class="col-xl-6 col-md-6 col-sm-12 px-1 mt-2">
                    <label class="content__form__title__label__duvida">
                        Contribuição Facultativa
                        <duvida
                            [textoAviso]="'contribuição periódica mensal de percentual previamente definido pelo participante, não aplicada sobre o 13º salário.'">
                        </duvida>
                    </label>
                    <input class="form-control" prefix="R$ " maxlength="14"
                        [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" currencyMask
                        formControlName="contribuicaoFacultativa" placeholder="R$ 0,00" />
                </div>
                <div class="col-xl-6 col-md-6 col-sm-12 px-1 mt-2">
                    <label class="content__form__title__label__duvida">
                        Contribuição Participante
                        <duvida
                            [textoAviso]="'Contribuição calculada com base de cálculo no Salário Real de Contribuição (SRC).'">
                        </duvida>
                    </label>
                    <input class="form-control" prefix="R$ " maxlength="14"
                        [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" currencyMask
                        formControlName="contribuicaoParticipante" placeholder="R$ 0,00" />
                </div>
                <div class="col-xl-4 col-md-4 col-sm-12 px-1 mt-2">
                    <label class="content__form__title__label__duvida">
                        Contribuição Patrocinadora
                        <duvida [textoAviso]="'Contribuição paritária em relação a Contribuição do Participante.'">
                        </duvida>
                    </label>
                    <input class="form-control" prefix="R$ " maxlength="14"
                        [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" currencyMask
                        formControlName="contribuicaoPatrocinadora" placeholder="R$ 0,00" />
                </div>
                <div class="col-xl-4 col-md-4 col-sm-12 px-1 mt-2">
                    <label class="content__form__title__label__duvida">
                        Estimativa de Rentabilidade
                        <duvida
                            [textoAviso]="'Corresponde ao retorno dos investimentos que incide na reserva de poupança do participante. É possível simular em 4%, 5% ou 6%.'">
                        </duvida>
                    </label>
                    <ng-select placeholder="Selecione" formControlName="taxaJuros" [items]="this.taxa" [searchable]="false">
                        <ng-template>
                            {{taxa}}%
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col-xl-4 col-md-4 col-sm-12 px-1 mt-2">
                    <label class="content__form__title__label__duvida">
                        Aporte
                        <duvida
                            [textoAviso]="'Contribuição esporádica, de qualquer valor, realizada pelo participante através de boleto.'">
                        </duvida>
                    </label>
                    <input class="form-control" prefix="R$ " maxlength="14"
                        [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" currencyMask
                        formControlName="aporte" placeholder="R$ 0,00" />
                </div>
                <div class="col-xl-4 col-md-4 col-sm-12 px-1 mt-2">
                    <label class="content__form__title__label__duvida">
                        Idade Prevista
                        <duvida
                            [textoAviso]="'Idade para qual deseja se aposentar. O simulador já indica como inicial a idade em que o participante cumpre todas as carências para receber o benefício.'">
                        </duvida>
                    </label>
                    <input class="form-control" min="{{valorMinimoIdade}}" [max]="valorMaximoIdade" type="number"
                        formControlName="anoAposentar" />
                </div>
                <div class="col-xl-4 col-md-4 col-sm-12 px-1 mt-2">
                    <label class="content__form__title__label__duvida">
                        Meses Previsto
                        <duvida [textoAviso]="'Complemento de meses para a idade em que deseja se aposentar.'"></duvida>
                    </label>
                    <ng-select [items]="this.meses" bindLabel="asc" bindValue="asc" placeholder="Selecione" [searchable]="false"
                        formControlName="mesAposentar" appendTo="body">
                    </ng-select>
                </div>
            </section>
            <div class="col-12 p-0 content__form__buttons">
                <button class="btn button-primary col-xl-2 col-lg-3 col-md-4 col-sm-12 mr-xl-1 mr-lg-1" type="submit"
                    [disabled]="this.loading">
                    <div class="d-flex" *ngIf="loading; else showSpan">
                        <span class="spinner">
                        </span>
                        <span> Simulando</span>
                    </div>
                    <ng-template #showSpan>
                        <span>Simular</span>
                    </ng-template>
                </button>
            </div>
        </form>
        <ng-template #showLoading>
            <spinner [show]="loading"></spinner>
        </ng-template>
        <div class="content_download_pdf">
            <div>
                <h5>
                    Exportar
                </h5>
            </div>
            <button>
                <fa-icon [icon]="faPdf" (click)="printPdf()"></fa-icon>
            </button>
        </div>
        <section *ngIf="simulation">
            <section class="row main__page__content__resultado" *ngIf="!loading else showLoading">
                <section class="col-xl-6 col-md-12 col-sm-12 main__page__content__resultado__proventos">
                    <h3 class="resultado__proventos__title">Proventos</h3>
                    <section class="resultado__proventos__content">
                        <section class="content__header__table">
                            <div class="col-xl-3">Verba</div>
                            <div class="col-xl-6">Descrição</div>
                            <div class="col-xl-3">Valor (R$)</div>
                        </section>
                        <section class="content__main__table">
                            <div class="table__card"
                                *ngFor="let provento of this.simulation.proventos; let firstItem = first">
                                <div class="col-xl-3">
                                    <span>{{ provento.verba }}</span>
                                </div>
                                <div class="col-xl-6">
                                    <span>{{ provento.descricao }}</span>
                                </div>
                                <div class="col-xl-3 text-center">
                                    <span>{{ provento.valor | currency:'BRL' }}</span>
                                </div>
                            </div>
                        </section>
                        <div class="proventos__content__valor__total">
                            <span class="valor__total__title col-8">Total Proventos</span>
                            <span class="valor__total__value col-4">{{ simulation.totalProventos |
                                currency:'BRL'}}</span>
                        </div>
                    </section>
                </section>
                <section class="col-xl-6 col-md-12 col-sm-12 main__page__content__resultado__descontos">
                    <h3 class="resultado__descontos__title">Descontos</h3>
                    <section class="resultado__descontos__content">
                        <section class="content__header__table">
                            <div class="col-xl-3">Verba</div>
                            <div class="col-xl-6">Descrição</div>
                            <div class="col-xl-3">Valor (R$)</div>
                        </section>
                        <section class="content__main__table">
                            <div class="table__card"
                                *ngFor="let desconto of this.simulation.descontos; let firstItem = first">
                                <div class="col-xl-3">
                                    <span>{{ desconto.verba }}</span>
                                </div>
                                <div class="col-xl-6">
                                    <span>{{ desconto.descricao }}</span>
                                </div>
                                <div class="col-xl-3 text-center">
                                    <span>{{ desconto.valor | currency:'BRL' }}</span>
                                </div>
                            </div>
                        </section>
                        <div class="descontos__content__valor__total">
                            <span class="valor__total__title col-8">Total Descontos (Opção IR Tabela
                                Progressiva):</span>
                            <span class="valor__total__value col-4">{{ simulation.totalDescontosProgressivo |
                                currency:'BRL'}}</span>
                        </div>
                        <div class="descontos__content__valor__total">
                            <span class="valor__total__title col-8">Total Descontos (Opção IR Tabela Regressiva):</span>
                            <span class="valor__total__value col-4">{{ simulation.totalDescontosRegressivo |
                                currency:'BRL'}}</span>
                        </div>
                    </section>
                </section>
            </section>
            <section class="main__page__content__avisos">
                <section class="content__avisos__resultado">
                    <div class="col-4 content__avisos__provento" *ngIf="simulation?.totalProventos">
                        <span>Provento: </span>
                        <span>{{ simulation?.totalProventos | currency:'BRL' }}</span>
                    </div>
                    <div class="col-4 content__avisos__desconto">
                        <span>Desconto (Opção IR Tabela Progressiva): </span>
                        <span>{{ simulation?.totalDescontosProgressivo | currency:'BRL' }}</span>
                    </div>
                    <div class="col-4 content__avisos__liquido">
                        <span>Líquido: </span>
                        <span>
                            {{ simulation?.totalLiquidoProgressivo | currency:'BRL' }}
                        </span>
                    </div>
                </section>
                <section class="content__avisos__resultado">
                    <div class="col-4 content__avisos__provento" *ngIf="simulation?.totalProventos">
                        <span>Provento: </span>
                        <span>{{ simulation?.totalProventos | currency:'BRL' }}</span>
                    </div>
                    <div class="col-4 content__avisos__desconto">
                        <span>Desconto (Opção IR Tabela Regressiva): </span>
                        <span>{{ simulation?.totalDescontosRegressivo | currency:'BRL' }}</span>
                    </div>
                    <div class="col-4 content__avisos__liquido">
                        <span>Líquido: </span>
                        <span>
                            {{ simulation?.totalLiquidoRegressivo | currency:'BRL' }}
                        </span>
                    </div>
                </section>
                <aviso [textoAviso]="'Benefício bruto formado na data atual'"
                    [valor]="simulation?.beneficioHoje | currency:'BRL'">
                </aviso>
            </section>
            <section class="main__page__content__dados__adicionais">
                <h3>Dados Adicionais</h3>
                <section class="col-12 content__dados__adicionais">
                    <div class="col-sm-12 px-1">
                        <span>Salário Real de Contribuição</span>
                        <p>{{simulation.salario | currency:'BRL'}}</p>
                    </div>
                    <div class="col-sm-12 px-1">
                        <span>Ultima Contribuição</span>
                        <p>{{simulation.ultimaContribuicao | currency:'BRL'}}</p>
                    </div>
                    <div class="col-sm-12 px-1">
                        <span>Saldo de Reserva de Poupança</span>
                        <p>{{simulation.saldoReserva | currency:'BRL'}}</p>
                    </div>
                    <div class="col-sm-12 px-1">
                        <span>Valor da Cota Atual</span>
                        <p>{{simulation.cotaAtual | currency:'BRL':'symbol':'1.10-10':'pt-BR'}}</p>
                    </div>
                    <div class="col-sm-12 px-1">
                        <span>Data Base da Cota</span>
                        <p>{{simulation.cotaAtualDate | date:'dd/MM/yyyy' }}</p>
                    </div>
                </section>
            </section>
        </section>
    </main>
    <footer class="footer__page__content">
        <article class="footer__page__atencao">
            <p class="footer__title">ATENÇÃO</p>
            <br>
            <p class="footer__content footer__content__atencao">
                A simulação considera, para o cálculo do benefício futuro, a última contribuição do participante como
                sendo padrão para os próximos meses até a data aposentadoria.
                Nos meses em que houver verbas como 13º, férias, por exemplo, a contribuição do participante será maior,
                resultando em uma projeção do benefício também maior.
                Cabe ressaltar que a simulação é uma projeção e não representa garantia ou compromisso de pagamento do
                valor simulado. Contudo, para um valor mais próximo da realidade,
                a simulação deve ser feita em meses que não incidirem as verbas extras.
            </p>
        </article>
        <article class="footer__page__informacoes">
            <p class="footer__page__informacoes__title__informacoes footer__title">INFORMAÇÕES</p>
            <br>
            <p class="ml-1 content-informacoes"
                *ngIf="!simulation || simulation.totalProventos >= simulation.socialSecurityUnit * 2">
                Caso os valores apresentados ainda não estejam dentro da sua expectativa, existem formas de melhorar o
                seu benefício, como contribuir por mais tempo, aumentar sua contribuição extra mensal ou realizar
                aportes.
            </p>
            <p class="footer__content"
                *ngIf="simulation && simulation.totalProventos < simulation.socialSecurityUnit * 2">
                Como o valor mínimo do seu benefício não pode ser abaixo de {{simulation.socialSecurityUnit * 2 |
                currency:'BRL' }} (valor equivalente a 2 unidades previdenciárias), suas alternativas são contribuir por
                mais tempo,
                aumentar sua contribuição extra mensal ou realizar um aporte para {{simulation.aporteFaltanteHoje |
                currency:'BRL'}}. Caso não seja possível, será necessário um aporte, na idade de aposentadoria, no valor
                de {{simulation.aporteFaltanteProjetado | currency:'BRL'}}.
            </p>
            <br>
            <p class="footer__page__informacoes__title__notas footer__title mt-1">NOTAS</p>
            <br>
            <div>
                <ul class="footer__content__notas">
                    <li>O resultado dessa simulação é uma projeção que não se constitui, de modo algum, em garantia,
                        proposta ou obrigação por parte da Fundação Copel.</li>
                    <li>O valor do saldo projetado foi estimado com base em uma hipótese de rentabilidade que você
                        simulou na fase de capitalização, porém, a rentabilidade real dependerá da performance das
                        aplicações.</li>
                    <li>Para a conversão em renda foi utilizada a hipótese de taxa de juros vigente.</li>
                    <li>O valor do aporte apresentado, quando for o caso, representa apenas uma das condições para a
                        elegibilidade para o benefício.
                        Deverão ser verificadas as demais condições de elegibilidade como idade e tempo de filiação.
                    </li>
                    <li>Os valores simulados podem ter variação de acordo com o motivo do desligamento. Havendo dúvidas
                        favor entrar em contato com nossa Central de Atendimento</li>
                </ul>
            </div>
        </article>
    </footer>
</section>